import { ITheme, IFontConfig } from "../@interfaces/theme.interface";

export function setThemedCssVariables(theme: ITheme) {
  if (!theme?.palette) {
    return;
  }

  document.documentElement.style.setProperty("--fow-primary-main-color", theme.palette.primary.main);
  document.documentElement.style.setProperty("--fow-primary-light-color", theme.palette.primary.light);
  document.documentElement.style.setProperty("--fow-primary-dark-color", theme.palette.primary.dark);

  document.documentElement.style.setProperty("--fow-secondary-main-color", theme.palette.secondary.main);
  document.documentElement.style.setProperty("--fow-secondary-light-color", theme.palette.secondary.light);
  document.documentElement.style.setProperty("--fow-secondary-dark-color", theme.palette.secondary.dark);

  document.documentElement.style.setProperty("--fow-accent-main-color", theme.palette.accent.main);
  document.documentElement.style.setProperty("--fow-accent-light-color", theme.palette.accent.light);
  document.documentElement.style.setProperty("--fow-accent-dark-color", theme.palette.accent.dark);
}

export function setFontFamilyCssVariables(fontConfig: IFontConfig) {
  document.documentElement.style.setProperty("--common-heading-font", fontConfig.heading);
  document.documentElement.style.setProperty("--common-body-font", fontConfig.body);
}
